import { AggregateDescriptor, CompositeFilterDescriptor, FilterDescriptor, State,  isCompositeFilterDescriptor,  process } from "@progress/kendo-data-query";

export const footerItemsField = [
    { field: "buyerGrossValue", sum: 0.00, hasFilter: false },
    { field: "buyerValue", sum: 0.00 , hasFilter: false },
    { field: "quantity", sum: 0.00 , hasFilter: false},
    { field: "numberOfUnits", sum: 0.00 , hasFilter: false},
    { field: "roundWeight", sum: 0.00 , hasFilter: false},
    { field: "grossWeight", sum: 0.00 , hasFilter: false},
];

const baseAggregateFields: AggregateDescriptor[] = footerItemsField.filter(f => f.field !== "grossWeight").map((item) => ({ 
    field: item.field, 
    aggregate: "sum" 
}));

const priceAggregateFields: AggregateDescriptor[] = [
    { field: "buyerPrice", aggregate: "max",  },
    { field: "buyerPrice", aggregate: "min" },
    { field: "buyerPrice", aggregate: "average" },
    { field: "grossWeight", aggregate: "max",  },
    { field: "grossWeight", aggregate: "min" },
    { field: "grossWeight", aggregate: "average" },
    { field: "grossWeight", aggregate: "sum" }
];

const aggregatesFields: AggregateDescriptor[] = [ ...baseAggregateFields, ...priceAggregateFields ];



const handleFilteredItem = (
    filters: CompositeFilterDescriptor
): { field: string; values: any[] }[] => {
    const clonedFilters: CompositeFilterDescriptor = JSON.parse(JSON.stringify(filters));
    const result: { field: string; values: any[] }[] = [];

    const processFilter = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        if (isCompositeFilterDescriptor(filter)) {
            (filter as CompositeFilterDescriptor).filters.forEach((f) => processFilter(f));
        } else {
            const singleFilter: FilterDescriptor = { ...filter } as FilterDescriptor;
            // const data = salesStatisticsGridColumnItems( {data: []}).find((col) => col.field === singleFilter.field);
            // if (data) {
            //     singleFilter.field = data.field;
            //     singleFilter.value = singleFilter.value || null;
            // }
            if (!singleFilter.field || typeof singleFilter.field !== "string") {
                return;
            }
            const existingItem = result.find((r) => r.field === singleFilter.field);
            if (existingItem) {
                existingItem.values.push(singleFilter.value);
            } else {
                result.push({ field: singleFilter.field, values: [singleFilter.value] });
            }
        }
    };

    clonedFilters.filters.forEach((f) => processFilter(f));
    return result;
};

export {   aggregatesFields,  handleFilteredItem };
